import React from 'react';
import { StyledBody } from './styles';

interface DrawerBodyProps {
  noPadding?: boolean;
  /** Grow to fill space below the header in next-variant drawers (flex column layout). */
  fillRemaining?: boolean;
}

const DrawerBody: React.FC<DrawerBodyProps> = ({ noPadding, fillRemaining, children }) => (
  <StyledBody $noPadding={noPadding} $fillRemaining={fillRemaining}>
    {children}
  </StyledBody>
);

export { DrawerBody };
